angular.module("jv.Candidate.Notes.Factory", ['jv'])
    .factory('jvNotesFactory',['candidates','$window', function(candidates, $window){
    
        return {
        deleteNote : function(postData, callBack){
            candidates.deleteNote(postData.applicationId, postData.id, function(response) {
                callBack(response);
            });
        },
        isEdittable: function(noteObj){
            if( !noteObj.to && $window.jvUser === noteObj.from.EId) {
                return true;
            }else{
                return false;
            }
        },
        isReplyable: function(noteObj,recipient){
            if( ($window.jvUser == recipient.EId) && (recipient.EId != noteObj.from.EId) ){
                return true;
            }
        },
        replyNote: function(noteObj){
            var note = angular.copy(noteObj);
            note.isNoteReply = true;
            this.openFlyout(note);
        },
        editNote:function(noteObj){
            this.openFlyout(noteObj);
        },
        openFlyout: function(noteObj){
            $scope = angular.element('.quickForms').scope();
            var eventData = {
                flyoutData : noteObj,
                flyoutType: 'note'
            };
            $scope.$emit('openFlyout',eventData);
        },
        saveNote : function(form,index,popoutAttachments,applicationId,callBack){
            var data = {},
                queryString = {value: ''},
                temp,
                to = [];
            //var form = {};
            form.attachmentEids = [];

            if(form.to && form.to.length){
                angular.forEach(form.to, function(recipient, key) {
                    to.push(recipient.EId);
                });
            }else{
                if( angular.isObject(form.to) ){
                    var toList = angular.copy(form.to);
                    to.push(toList.EId);
                }
            }

            var clone_form = angular.copy(form);
            clone_form.to = to;
            form.attachmentEids=[];
            if(!form.content || !form.subject || form.subject.length > 150){
                return false;
            }
            
            data.content = form.content;
            data.subject = form.subject
        
            
            if (clone_form.to.length > 0)
            {
            	data.toList = clone_form.to
            }

            if(popoutAttachments.length){
                angular.forEach(popoutAttachments, function(value,key) {
                    if(value.EId){
                        form.attachmentEids.push(value.EId);
                    }
                });
                data.attachmentList = form.attachmentEids;
            }
            /*BE expects locale to be sent to determine language for Email header/footer*/
            if(form && form.template && form.template.locale){
            	data.locale = form.template.locale;
            }
            if(form.EId){
                //$scope.flags.loading = true;
                candidates.updateNote(applicationId, form.EId, data, function(response) {
                    callBack(response);
                });
            }
            else{
                //$scope.flags.loading = true;
                candidates.addNote(applicationId, data, function(response) {
                    callBack(response);
                });
            }

        }

    };
}]);
